const states = [
  { abbr: 'al', name: 'Alabama' }, { abbr: 'ak', name: 'Alaska' }, { abbr: 'az', name: 'Arizona' },
  { abbr: 'ar', name: 'Arkansas' }, { abbr: 'ca', name: 'California' }, { abbr: 'co', name: 'Colorado' },
  { abbr: 'ct', name: 'Connecticut' }, { abbr: 'de', name: 'Delaware' }, { abbr: 'fl', name: 'Florida' },
  { abbr: 'ga', name: 'Georgia' }, { abbr: 'hi', name: 'Hawaii' }, { abbr: 'id', name: 'Idaho' },
  { abbr: 'il', name: 'Illinois' }, { abbr: 'in', name: 'Indiana' }, { abbr: 'ia', name: 'Iowa' },
  { abbr: 'ks', name: 'Kansas' }, { abbr: 'ky', name: 'Kentucky' }, { abbr: 'la', name: 'Louisiana' },
  { abbr: 'me', name: 'Maine' }, { abbr: 'md', name: 'Maryland' }, { abbr: 'ma', name: 'Massachusetts' },
  { abbr: 'mi', name: 'Michigan' }, { abbr: 'mn', name: 'Minnesota' }, { abbr: 'ms', name: 'Mississippi' },
  { abbr: 'mo', name: 'Missouri' }, { abbr: 'mt', name: 'Montana' }, { abbr: 'ne', name: 'Nebraska' },
  { abbr: 'nv', name: 'Nevada' }, { abbr: 'nh', name: 'New Hampshire' }, { abbr: 'nj', name: 'New Jersey' },
  { abbr: 'nm', name: 'New Mexico' }, { abbr: 'ny', name: 'New York' }, { abbr: 'nc', name: 'North Carolina' },
  { abbr: 'nd', name: 'North Dakota' }, { abbr: 'oh', name: 'Ohio' }, { abbr: 'ok', name: 'Oklahoma' },
  { abbr: 'or', name: 'Oregon' }, { abbr: 'pa', name: 'Pennsylvania' }, { abbr: 'ri', name: 'Rhode Island' },
  { abbr: 'sc', name: 'South Carolina' }, { abbr: 'sd', name: 'South Dakota' }, { abbr: 'tn', name: 'Tennessee' },
  { abbr: 'tx', name: 'Texas' }, { abbr: 'ut', name: 'Utah' }, { abbr: 'vt', name: 'Vermont' },
  { abbr: 'va', name: 'Virginia' }, { abbr: 'wa', name: 'Washington' }, { abbr: 'wv', name: 'West Virginia' },
  { abbr: 'wi', name: 'Wisconsin' }, { abbr: 'wy', name: 'Wyoming' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] pt-14 pb-8 px-6" role="contentinfo">
      <div className="max-w-screen-xl mx-auto">
        {/* Brand + nav */}
        <div className="flex flex-col sm:flex-row items-start justify-between gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center bg-[#FF6B00] rounded-md flex-shrink-0">
                <i className="ri-home-gear-fill text-white text-lg" />
              </div>
              <span className="text-white font-bold text-lg tracking-tight font-heading">
                HomePro<span className="text-[#FF6B00]">Dispatch</span>
              </span>
            </div>
            <p className="text-white/50 text-xs font-body max-w-xs leading-relaxed">
              Connecting homeowners with pre-vetted, licensed local service professionals across all 50 states. Available 24/7.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {[
              { label: 'Privacy Policy', href: '/privacy-policy/', external: false },
              { label: 'Terms of Service', href: '/terms-of-service/', external: false },
              { label: 'California Notice', href: '/california-notice/', external: false },
              { label: 'Contractor Login', href: '/contractor-login/', external: false },
              { label: 'Apply as Contractor', href: '/apply/', external: false },
              { label: 'Contact', href: '/contact/', external: false },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-white/50 text-xs font-body hover:text-white transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* State directory */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <h4 className="text-white/40 text-xs font-bold uppercase tracking-widest font-heading mb-4">
            <a id="state-directory" href="#state-directory">Service Areas by State</a>
          </h4>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            {states.map((state) => (
              <a
                key={state.abbr}
                href={`/${state.abbr}/`}
                className="text-white/40 text-xs font-body hover:text-[#10B981] transition-colors whitespace-nowrap"
              >
                {state.name}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright + disclaimer */}
        <div className="border-t border-white/10 pt-6">
          <p className="text-white/30 text-xs font-body text-center mb-3">
            HomePro Dispatch &copy; {new Date().getFullYear()}. All rights reserved.
          </p>
          <p className="text-white/20 text-xs font-body leading-relaxed text-center max-w-4xl mx-auto">
            HomePro Dispatch is a free referral service connecting homeowners with independent local contractors. We do not warrant or guarantee any work performed. Users are responsible for verifying contractor licenses, certifications, and insurance. By submitting your information, you authorize HomePro Dispatch and its service partners to contact you via live calls, auto-dialed, pre-recorded calls, and/or SMS. Standard message and data rates may apply. Consent is not a condition of purchase.
          </p>
        </div>
      </div>
    </footer>
  );
}
